import React, { useState, useEffect } from "react";
import "./FolderDetail.css";
import FilledButton from "../../../../../components/molecules/buttons/filledButton/FilledButton";
import Folder from "../../../../../components/atoms/icons/folder/folder/Folder";
import Deliverable from "../../../../../components/atoms/icons/folder/deliverable/Deliverable";
import FolderInfo from "./tabs/folderInfo/FolderInfo";
import FolderDeliverables from "./tabs/folderDeliverables/FolderDeliverables";
import Emc from "../../../../../components/atoms/icons/header/emc/Emc";
import Rapport from "../../../../../components/atoms/icons/header/rapport/Rapport";
import Dashboard from "../../../../../components/atoms/icons/folder/dashboard/Dashboard";
import Chart from "../../../../../components/atoms/icons/header/chart/Chart";
import { useParams } from "react-router-dom";
import CrmResourcesMenu from "../../../../../components/crmComponents/crmResourcesMenu/CrmResourcesMenu";
import Loader from "../../../../../components/organisms/loader/Loader";
import FolderResources from "./tabs/folderResources/FolderResources";
import { useResources } from "../../../../../context/ResourcesContext";
import Warning from "../../../../../components/atoms/icons/general/warning/Warning";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../../context/AuthContext";
import ArrowSm from "../../../../../components/atoms/icons/general/arrowSm/ArrowSm";

function FolderDetail() {
  const tabs = [
    {
      label: "Contenu du dossier",
      Icon: Dashboard,
      name: "info",
    },
    {
      label: "Estimations",
      Icon: Emc,
      name: "estimations",
    },
    {
      label: "Plans de financement",
      Icon: Rapport,
      name: "financingPlans",
    },
    {
      label: "Simulations de prêt",
      Icon: Chart,
      name: "creditSimulations",
    },
    {
      label: "Livrables",
      Icon: Deliverable,
      name: "deliverables",
    },
  ];
  const { fetchUserSingleResource, archiveResource } = useResources();
  const { tabParam, subTabParam } = useParams();
  const { accesses } = useAuth();

  const [folder, setFolder] = useState(null);
  const [isFolderUpdatable, setIsFolderUpdatable] = useState(true);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [isLoaderVisible, setIsLoaderVisible] = useState(true);
  const [folderUpdateTrigger, setFolderUpdateTrigger] = useState(0);
  const [isArchiveButtonLoading, setIsArchiveButtonLoading] = useState(false);

  useEffect(() => {
    if (tabParam === "mes-dossiers") fetchFolder(subTabParam);
  }, [tabParam, subTabParam, folderUpdateTrigger]);

  useEffect(() => {
    if (folder) setIsFolderUpdatable(folder.is_updatable || accesses?.includes("unrestricted"));
  }, [folder, accesses]);

  async function fetchFolder(folderUuid) {
    const folder = await fetchUserSingleResource(folderUuid, "folders");
    setFolder(folder);
    setIsLoaderVisible(false);
  }

  async function archiveFolder(folder, shouldArchive) {
    setIsArchiveButtonLoading(true);
    await archiveResource(folder, shouldArchive, "folders", () => fetchFolder(subTabParam));
    setIsArchiveButtonLoading(false);
  }

  function selectTab(tabName) {
    setActiveTab(tabs.find(tab => tab.name === tabName));
  }

  return (
    <section className='container folder-detail-container'>
      <div className='crm-client-view-container'>
        <CrmResourcesMenu
          title={
            <>
              <Folder />
              {folder?.name}
            </>
          }>
          {tabs.map(tab => (
            <div
              key={tab.name}
              className={`crm-resource-menu-item ${activeTab.name === tab.name ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}>
              <tab.Icon width='23px' />
              {tab.label}
            </div>
          ))}
          <FilledButton
            bgColor='#FDB7A9'
            color='var(--dark-blue)'
            hoverColor='#FDB7A9'
            isLoading={isArchiveButtonLoading}
            className='w-100 mt-lg'
            onClick={() => archiveFolder(folder, !folder?.archived)}>
            {folder?.archived ? "Désarchiver le dossier" : "Archiver le dossier"}
          </FilledButton>
        </CrmResourcesMenu>
        <div className='crm-items-container folder-items-container'>
          <Loader visible={isLoaderVisible} className='folder-loader' preventScrolling={false} />
          {!isFolderUpdatable && (
            <div className='form-disabled-warning'>
              <Warning />
              Votre abonnement étant échu, vous pouvez seulement consulter vos dossiers.{" "}
              <Link to={`/tarifs?fallback_url=/mon-compte/mes-dossiers/${subTabParam}`}>
                Renouveler mon abonnement.
              </Link>
            </div>
          )}
          {activeTab.name === "info" ? (
            <FolderInfo
              folder={folder}
              triggerFolderUpdate={() => setFolderUpdateTrigger(prev => prev + 1)}
              selectTab={selectTab}
              isFolderUpdatable={isFolderUpdatable}
            />
          ) : activeTab.name === "deliverables" ? (
            <FolderDeliverables
              folder={folder}
              triggerFolderUpdate={() => setFolderUpdateTrigger(prev => prev + 1)}
              isFolderUpdatable={isFolderUpdatable}
            />
          ) : (
            <FolderResources
              folder={folder}
              isFolderUpdatable={isFolderUpdatable}
              resources={folder ? folder[activeTab.name] : []}
              activeTab={activeTab}
              triggerFolderUpdate={() => setFolderUpdateTrigger(prev => prev + 1)}
            />
          )}
        </div>
      </div>
    </section>
  );
}

export default FolderDetail;
